// extracted by mini-css-extract-plugin
module.exports = {"root":"IEDeprecationBanner_root__31oDk","text":"IEDeprecationBanner_text__vG4Nr","link":"IEDeprecationBanner_link__2tOAk"};